import React from "react";
import Customform from "../../ui/custom-form";
import CustomInput from "../../ui/custom-input";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CustomButton from "../../ui/custom-button";
import PhoneIcon from "@mui/icons-material/Phone";
import BusinessIcon from "@mui/icons-material/Business";
import WebIcon from "@mui/icons-material/Web";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { PulseLoader } from "react-spinners";
import { FaRegUser } from "react-icons/fa";

function Register({
  formInput,
  handleSubmit,
  handleChange,
  handleFileChange,
  loading,
}) {
  return (
    <Customform
      className="mt-4"
      onSubmit={handleSubmit}
      encType="multipart/form-data"
    >
      {/* Full Name */}
      <div className="withIcon mb-3">
        <label htmlFor="user_name">Full Name</label>
        <div className="position-relative">
          <span className="icon">
            <FaRegUser />
          </span>
          <CustomInput
            className="form-control"
            name="user_name"
            type="text"
            value={formInput.user_name}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* Gender */}

      <div className="inputData mb-3">
        <select
          className="form-select"
          name="gender"
          value={formInput.gender}
          onChange={handleChange}
        >
          <option value="">Select Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          <option value="Other">Other</option>
        </select>
      </div>

      {/* Organization Name */}
      <div className="withIcon my-3">
        <label htmlFor="organization_name">Organization Name</label>
        <div className="position-relative">
          <span className="icon">
            <BusinessIcon />
          </span>
          <CustomInput
            className="form-control"
            name="organization_name"
            type="text"
            value={formInput.organization_name}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* Industry ID */}
      {/* <div className="inputData withIcon my-3">
        <span className="icon">
          <WebIcon />
        </span>
        <CustomInput
          className="form-control"
          name="industry_id"
          type="text"
          value={formInput.industry_id}
          onChange={handleChange}
        />
        <label htmlFor="industry_id">Industry ID</label>
      </div> */}
      {/* Organization Location - Multiple Fields */}
      {/* Organization Locations */}
      <div className="my-3">
        {formInput.organization_location.map((loc, index) => (
          <div
            key={index}
            className="inputData withIcon mb-2 position-relative"
          >
            <span className="icon">
              <LocationOnIcon />
            </span>
            <CustomInput
              className="form-control my-2"
              name={`organization_location_${index}`}
              type="text"
              value={loc}
              onChange={(e) => {
                const newLocations = [...formInput.organization_location];
                newLocations[index] = e.target.value;
                handleChange({
                  target: {
                    name: "organization_location",
                    value: newLocations,
                  },
                });
              }}
            />
            <label htmlFor={`organization_location_${index}`}>
              Organization Location {index + 1}
            </label>

            {formInput.organization_location.length > 1 && (
              <button
                type="button"
                className="btn btn-sm btn-outline-danger position-absolute"
                style={{
                  top: "50%",
                  right: "-40px",
                  transform: "translateY(-50%)",
                }}
                onClick={() => {
                  const newLocations = formInput.organization_location.filter(
                    (_, i) => i !== index
                  );
                  handleChange({
                    target: {
                      name: "organization_location",
                      value: newLocations,
                    },
                  });
                }}
              >
                &minus;
              </button>
            )}
          </div>
        ))}

        <div className="mt-2">
          <CustomButton
            type="button"
            size="small"
            onClick={() =>
              handleChange({
                target: {
                  name: "organization_location",
                  value: [...formInput.organization_location, ""],
                },
              })
            }
          >
            + Add Location
          </CustomButton>
        </div>
      </div>

      {/* Org Email */}
      <div className="withIcon mb-3">
        <label htmlFor="org_email">Organization Email</label>
        <div className="position-relative">
          <span className="icon">
            <MailOutlineIcon />
          </span>
          <CustomInput
            className="form-control"
            name="org_email"
            type="email"
            value={formInput.org_email}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* User Email */}
      <div className="withIcon mb-3">
        <label htmlFor="email">User Email</label>
        <div className="position-relative">
          <span className="icon">
            <MailOutlineIcon />
          </span>
          <CustomInput
            className="form-control"
            name="email"
            type="email"
            value={formInput.email}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* Mobile Number */}
      <div className="withIcon mb-3">
        <label htmlFor="mobile_number">Mobile Number</label>
        <div className="position-relative">
          <span className="icon">
            <PhoneIcon />
          </span>
          <CustomInput
            className="form-control"
            name="mobile_number"
            type="text"
            value={formInput.mobile_number}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* Image Upload */}
      <div className="mb-3">
        <label htmlFor="image">Upload Image</label>
        <input
          className="form-control"
          type="file"
          name="image"
          accept="image/*"
          onChange={handleFileChange}
        />
      </div>

      {/* Submit Button */}

      {loading ? (
        <button className="codepenButton submitBtn w-100 mb-3" type="submit">
          <span className="loader">
            <PulseLoader color="#fff" />
          </span>
        </button>
      ) : (
        <button type="submit" className="codepenButton submitBtn w-100 mb-3">
          <span>Add</span>
        </button>
      )}
    </Customform>
  );
}

export default Register;
